'use es6';

import UIButton from 'UIComponents/button/UIButton';
import styled from 'styled-components';
import { OBSIDIAN, OLAF, CALYPSO_LIGHT } from 'HubStyleTokens/colors';
export default styled(UIButton).withConfig({
  displayName: "StyleProtectedMenuButton",
  componentId: "sc-1ltaxpd-0"
})(["color:", " !important;background-color:", " !important;&:hover{background-color:", " !important;}"], OBSIDIAN, OLAF, CALYPSO_LIGHT);